import * as api from "api"
import { form_list, user_info } from "signals/user"
import { catch_error } from "./base"
import { err_msg, getSsObject, isGeneralDomain } from "helper"
import { toggleModal, toggleToast } from "signals/modal"
import { toggleLoader } from "signals/base"
import { adjustInitialFormData, changeFormData, form_field } from "signals/form"

const get_info = () => {
	toggleLoader(true)
	api
		.info()
		.then((response) => {
			let user = response.data.data
			user_info.value = user
			form_field.value = [...form_field.value, ...user.extra_fields]
			adjustInitialFormData()
			changeFormData("nickname", user?.nickname)
			changeFormData("uid", user?.uid)
			if(isGeneralDomain()) return;
			const agreed = getSsObject("hasAgreed")
			if (!agreed) {
				toggleModal({ name: "terms", state: true })
			}
		})
		.catch((err) => {
			/** Handle error , show modal or toast error */
			catch_error(err_msg(err))
		})
		.then(() => {
			toggleLoader(false)
		})
}

const get_list_form = () => {
	toggleLoader(true)
	api
		.list_form()
		.then((response) => {
			const { forms } = response.data.data
			form_list.value = forms
		})
		.catch((err) => {
			/** Handle error , show modal or toast error */
			catch_error(err_msg(err))
		})
		.then(() => {
			toggleLoader(false)
		})
}

const change_favorite = (params) => {
	toggleLoader(true)
	api
		.favorite(params)
		.then((response) => {
			get_list_form()
			toggleToast({
				msg: `toast_success_change_favorite`,
				state: true,
				type: "success",
			})
		})
		.catch((err) => {
			catch_error(err_msg(err))
		})
		.then(() => {
			toggleLoader(false)
		})
}

const remove_address = (payload) => {
	toggleLoader(true)
	api
		.remove({
			form_id: payload.id,
			event: payload.event,
		})
		.then((response) => {
			get_list_form()
			toggleToast({
				msg: `toast_success_delete_form`,
				state: true,
				type: "success",
			})
		})
		.catch((err) => {
			catch_error(err_msg(err))
		})
		.then(() => {
			toggleModal({ name: "confirm" })
			toggleLoader(false)
		})
}

export { get_info, get_list_form, change_favorite, remove_address }
